class LocalizationFormComponent extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.countryInput = this.querySelector('[data-localization-country-input]');
    this.languageInput = this.querySelector('[data-localization-language-input]');
    this.searchInput = this.querySelector('[data-localization-search]');
    this.resetButton = this.querySelector('[data-localization-reset]');
    this.emptyMessage = this.querySelector('[data-localization-empty]');
    this.liveRegion = this.querySelector('[data-localization-live]');

    this.addEventListener('click', this.handleClick);
    this.searchInput?.addEventListener('input', this.handleSearch);
    this.resetButton?.addEventListener('click', this.handleReset);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.searchInput?.removeEventListener('input', this.handleSearch);
    this.resetButton?.removeEventListener('click', this.handleReset);
  }

  handleClick = (event) => {
    const countryButton = event.target instanceof Element ? event.target.closest('[data-localization-country]') : null;
    if (countryButton && this.countryInput && this.form) {
      const countryCode = countryButton.getAttribute('data-value');
      if (!countryCode) return;

      this.countryInput.value = countryCode;
      this.form.requestSubmit();
      return;
    }

    const languageButton = event.target instanceof Element ? event.target.closest('[data-localization-language]') : null;
    if (!languageButton || !this.languageInput || !this.form) return;

    const languageCode = languageButton.getAttribute('data-value');
    if (!languageCode) return;

    this.languageInput.value = languageCode;
    this.form.requestSubmit();
  };

  handleSearch = () => {
    const query = this.searchInput?.value.trim().toLowerCase() || '';
    const items = Array.from(this.querySelectorAll('[data-localization-country-item]'));
    let visibleCount = 0;

    for (const item of items) {
      const haystack = item.getAttribute('data-search') || '';
      const isVisible = query === '' || haystack.includes(query);
      item.toggleAttribute('hidden', !isVisible);
      if (isVisible) visibleCount += 1;
    }

    this.resetButton?.toggleAttribute('hidden', query === '');
    this.emptyMessage?.toggleAttribute('hidden', visibleCount > 0);

    const label = this.getAttribute('data-results-label');
    if (this.liveRegion && label) {
      this.liveRegion.textContent = label.replace('[count]', String(visibleCount));
    }
  };

  handleReset = () => {
    if (!this.searchInput) return;

    this.searchInput.value = '';
    this.handleSearch();
    this.searchInput.focus();
  };
}

class DropdownLocalizationComponent extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-localization-toggle]');
    this.panel = this.querySelector('[data-localization-panel]');

    this.button?.addEventListener('click', this.handleToggle);
    this.button?.addEventListener('keydown', this.handleButtonKeydown);
    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleToggle);
    this.button?.removeEventListener('keydown', this.handleButtonKeydown);
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleKeydown);
  }

  get isOpen() {
    return this.panel ? !this.panel.hasAttribute('hidden') : false;
  }

  handleToggle = (event) => {
    event.preventDefault();
    this.togglePanel();
  };

  handleDocumentClick = (event) => {
    if (!this.isOpen) return;
    if (event.target instanceof Node && this.contains(event.target)) return;

    this.closePanel();
  };

  handleButtonKeydown = (event) => {
    if (event.key !== 'ArrowDown') return;

    event.preventDefault();
    this.openPanel();
  };

  handleKeydown = (event) => {
    if (event.key !== 'Escape' || !this.isOpen) return;

    this.closePanel();
    this.button?.focus();
  };

  togglePanel() {
    if (this.isOpen) {
      this.closePanel();
      return;
    }

    this.openPanel();
  }

  openPanel() {
    this.panel?.removeAttribute('hidden');
    this.button?.setAttribute('aria-expanded', 'true');
    const focusTarget =
      this.querySelector('[data-localization-search]') ||
      this.querySelector('[aria-current="true"] [data-localization-language]') ||
      this.querySelector('[data-localization-language], [data-localization-country]');
    focusTarget?.focus();
  }

  closePanel() {
    this.panel?.setAttribute('hidden', '');
    this.button?.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('localization-form-component')) {
  customElements.define('localization-form-component', LocalizationFormComponent);
}

if (!customElements.get('dropdown-localization-component')) {
  customElements.define('dropdown-localization-component', DropdownLocalizationComponent);
}
